// extracted by mini-css-extract-plugin
export default {"wrap":"aG-z","fullWidth":"bG-z","hideOnDesktop":"cG-z","content":"dG-z","hasOpenedNav":"eG-z","crumbsList":"fG-z","dropdownsWrap":"gG-z"};